import { navLinks } from "../../../mocks/starTracker";

export default function Footer() {
  return (
    <footer className="bg-background-100/80 pt-14">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-8 pb-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className="ri-focus-3-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">回声观察社</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注明星婚变等突发事件的后续进展追踪与编辑式复盘。把离婚诉讼、回应、道歉、封杀塌房串成可理解的时间线，陪你理性吃瓜、看全全貌。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-qq-line", "ri-rss-line"].map((i) => (
                <a
                  key={i}
                  href="#top"
                  onClick={(e) => e.preventDefault()}
                  aria-label="社交媒体入口"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-primary-600 hover:text-background-50"
                >
                  <i className={`${i} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-heading text-sm font-bold text-foreground-950">栏目导航</p>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById(l.id)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-heading text-sm font-bold text-foreground-950">编辑说明</p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              本社仅对公开、可交叉印证的信息做追踪与复盘，不虚构私密事实、不消费当事人情绪，并保护未成年人相关信息。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-700"></i>
              contact@echo-observe.example.com
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-200 py-5 sm:flex-row">
          <p className="text-xs text-secondary-500">© {new Date().getFullYear()} 回声观察社 · 保留所有权利</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href="#top" onClick={(e) => e.preventDefault()} className="text-xs text-secondary-500 hover:text-foreground-800 whitespace-nowrap">转载合作</a>
            <a href="#top" onClick={(e) => e.preventDefault()} className="text-xs text-secondary-500 hover:text-foreground-800 whitespace-nowrap">内容声明</a>
            <a href="#top" onClick={(e) => e.preventDefault()} className="text-xs text-secondary-500 hover:text-foreground-800 whitespace-nowrap">隐私说明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}